import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';
import type { Props } from './types';

const LazyBitbucketPendingConnectionBanner = lazyForPaint(() =>
	import(/* webpackChunkName: "async-devops-bitbucket-pending-connection-banner" */ './index').then(
		(module) => module.BitbucketPendingConnectionBanner,
	),
);

export const BitbucketPendingConnectionBannerAsync = (props: Props) => (
	<LazyBitbucketPendingConnectionBanner {...props} />
);
